import React, { useState } from 'react';
import classNames from 'classnames';
import Image, { ImageProps } from 'next/image';

interface IProps extends ImageProps {
  imageClassName?: string;
}

const ShimmerImage: React.FC<IProps> = ({ imageClassName, alt, objectFit, src, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        width: props.width,
        height: props.height
      }}
      className={props.className}
    >
      {!isLoaded && <div className="absolute inset-0 z-0 h-full w-full animate-pulse bg-gray-200" />}

      <Image
        {...props}
        src={src}
        alt={alt}
        title={alt}
        priority={props.priority}
        objectFit={objectFit ?? 'cover'}
        loading={props.priority ? undefined : (props?.loading || 'lazy')}
        onLoadingComplete={() => setIsLoaded(true)}
        className={classNames(isLoaded ? 'visible' : 'invisible', imageClassName)}
      />
    </div>
  );
};

export default ShimmerImage;
